import { render, staticRenderFns } from "./JMTZList.vue?vue&type=template&id=5dcd72e0&scoped=true&"
import script from "./JMTZList.vue?vue&type=script&lang=js&"
export * from "./JMTZList.vue?vue&type=script&lang=js&"
import style0 from "./JMTZList.vue?vue&type=style&index=0&id=5dcd72e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcd72e0",
  null
  
)

export default component.exports